import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { RecommendTsApi, RecommendTsRequest, RecommendTsResponse, ConfirmTsRequest, ConfirmTsResponse, RecommendTsSseMessage } from '../recommend-ts-api';
import { GuestAwareHttpService } from '../../services/guest-aware-http-service';
import { resolveApiPath } from '@/utils/api-path-resolver';
import { FactoryPsHttpSSE, type PsHttpSSE } from '@patsnap-utils/sse';
import { injectService } from '@patsnap/tahiti-core';

@injectable()
export class RecommendTsApiImpl extends GuestAwareHttpService implements RecommendTsApi {
    async getRecommendTs(request: RecommendTsRequest): Promise<RecommendTsResponse> {
        const res = await this.postWithGuestSupport<RecommendTsResponse>(
            {
                data: request,
            },
            'recommend_ts'
        );
        return res;
    }

    async getRecommendTsStream(request: RecommendTsRequest): Promise<PsHttpSSE<RecommendTsSseMessage>> {
        const sseClient = injectService<FactoryPsHttpSSE>(FactoryPsHttpSSE);
        const resolvedPath = await resolveApiPath('recommend_ts_sse');
        // 与 GuestAwareHttpService 保持一致：本地开发 baseURL 为空走 vite proxy，生产/QA 用 VITE_TELECOM_API
        const baseURL = import.meta.env.DEV ? '' : (import.meta.env.VITE_TELECOM_API || '');
        const url = `${baseURL}${resolvedPath}`;

        return sseClient<RecommendTsSseMessage>()
            .init({
                url,
                data: {
                    task_id: request.task_id,
                },
                hasFinalMessage: () => true,
            });
    }

    async confirmTs(request: ConfirmTsRequest): Promise<ConfirmTsResponse> {
        const res = await this.postWithGuestSupport<ConfirmTsResponse>(
            {
                data: request,
            },
            'recommend_ts/confirm'
        );
        return res;
    }
}
